import WebFont from 'webfontloader';

import BlogRecommended from './components/BlogRecommended';
import SolutionsVideo from './components/SolutionsVideo';
import Testimonials from './components/Testimonials';
import BlogOverview from './components/BlogOverview';
import RequestDemo from './components/RequestDemo';
import HowItWorks from './components/HowItWorks';
import Trackers from './components/Trackers';
import Reasons from './components/Reasons';
import Header from './components/Header';
import GoTo from './components/GoTo';
import Page from './Page';

WebFont.load({
  google: {
    families: [
      'Open Sans',
      'Inter',
    ],
  },
  active: () => {
    const page = new Page();

    page.addComponent(new Header());

    if (document.querySelector('.form')) {
      document.querySelectorAll('.form').forEach(($form) => {
        page.addComponent(new RequestDemo($form as HTMLFormElement));
      });
    }

    if (document.querySelector('.reasons')) {
      page.addComponent(new Reasons());
    }

    if (document.querySelector('.how-it-works')) {
      page.addComponent(new HowItWorks());
    }

    if (document.querySelector('.testimonials')) {
      page.addComponent(new Testimonials());
    }

    if (document.querySelector('.go-to')) {
      document.querySelectorAll('.go-to').forEach(($goTo) => {
        page.addComponent(new GoTo($goTo as HTMLElement));
      });
    }

    if (document.querySelector('.trackers')) {
      page.addComponent(new Trackers());
    }

    if (document.querySelector('.solutions')) {
      page.addComponent(new SolutionsVideo());
    }

    if (document.querySelector('.blog__cards.is-overview')) {
      page.addComponent(new BlogOverview());
    }

    if (document.querySelector('.blog__cards.is-recommended')) {
      page.addComponent(new BlogRecommended());
    }
  },
});
